import request from '../../../helpers/request';
import { fromDateStr, toDateStr } from '../../../helpers/utcDate';
import moment from 'moment';
import { useQuery } from 'react-query';

const getDashboard = async (fromDate, toDate, onlySelectedPeriod) => {
  const res = await request.get(
    '/Request/dashboard',
    {
      filterByCreateDate: true,
      stat: true,
      fromDate: fromDateStr(moment(fromDate)),
      toDate: toDateStr(moment(toDate)),
      onlySelectedPeriod,
    },
    'При загрузке дашборда произошла ошибка',
    [],
    undefined,
    'comma'
  );

  return res;
};

const useDasboard = (
  fromDate,
  toDate,
  onlySelectedPeriod = false,
  ...options
) =>
  useQuery(
    ['dashboard', fromDate, toDate, onlySelectedPeriod],
    () => getDashboard(fromDate, toDate, onlySelectedPeriod),
    {
      enabled: Boolean(fromDate) && Boolean(toDate),
      ...options,
    }
  );

export default useDasboard;
